import { fetcher } from '@commenda/utils';

import { IApiResponse } from './types';

export interface IDeleteDriveViewFolderParams {
  folderId: string;
}

export async function deleteDriveViewFolder({
  folderId,
}: IDeleteDriveViewFolderParams): Promise<IApiResponse<null>> {
  const response = await fetcher(`drive-view/folder/${folderId}`, {
    method: 'DELETE',
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    return {
      success: false,
      error: body?.message || 'Failed to delete folder',
      statusCode: response.status,
      data: null,
    };
  }

  return {
    success: true,
    error: null,
    statusCode: response.status,
    data: null,
  };
}
